import * as React from 'react';
import { IconButton, MenuItem, Popper, Grow, Paper, ClickAwayListener, MenuList, ListItemIcon, ListItemText } from '@material-ui/core';
import { ApplicationMain } from '../../../styles/common';

export default class CommonMenuComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            open: false,
            anchorEl: null,
        }

        this.handleClose = this.handleClose.bind(this);
        this.handleMenuItemClicked = this.handleMenuItemClicked.bind(this);
    }
    handleClick = (event: any) => {
        this.setState({ anchorEl: event.currentTarget });
    }
    componentDidMount() {
        this.setState({ open: this.props.open })
    }
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({ open: nextProps.open })
    }
    handleClose = () => {
        this.setState({ open: false });
        if(this.props.onClickAway){
            this.props.onClickAway();
        }
    }
    handleMenuItemClicked = (item: any) => {
        this.props.onMenuItemClicked(item);
        this.handleClose();
    }

    render() {
        return (
            <ApplicationMain>
                <div className="tooltipPopperWrapper">
                    <IconButton
                        aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                        className="MenuItem"
                    >
                        {this.props.icon && this.props.icon}
                    </IconButton>

                    <Popper open={this.state.open} transition={true} disablePortal={true} className="popperDropdownMenu">
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{ transformOrigin: 'center bottom' }}
                            >
                                <Paper className="popperDropdownPaper">
                                    <ClickAwayListener onClickAway={this.handleClose}>
                                        <div className="arrow-up" />
                                        <MenuList className="popperDropdownMenuList">
                                            {this.props.menuItems.map((mi: any) => {
                                                return (
                                                    <MenuItem key={mi.text} className={'popperDropdownMenuItem ' + mi.customCss} onClick={this.handleMenuItemClicked.bind(this, mi.clickIdentifier)}>
                                                        {mi.icon && (<ListItemIcon className="popperDropdownMenuIcon">
                                                            {mi.icon}
                                                        </ListItemIcon>)}
                                                        <ListItemText className="popperDropdownMenuText" primary={mi.text} />
                                                    </MenuItem>
                                                )
                                            })}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </div>

            </ApplicationMain> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/menu/CommonMenuComponent.tsx